import React from "react";
import { motion } from "framer-motion";
import mockMenuData from "../data/menulist";

const FoodGallery = () => {
  // Extract all food images from the menu data
  const foodImages = Object.values(mockMenuData)
    .flatMap((category) => category.flatMap((sub) => sub.items))
    .map((item) => item.image)
    .filter((img) => img); // Ensure no empty images

  return (
    <div className="container py-5 text-center" style={{ backgroundColor: "#111" }}>
      <h2 className="text-white mb-4">🍽️ Our Food Gallery</h2>
      <div className="row g-4 justify-content-center">
        {foodImages.map((image, index) => (
          <motion.div
            key={index}
            className="col-md-4 col-lg-3 col-sm-6"
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            whileHover={{ scale: 1.1, rotate: 2 }}
          >
            <img
              src={image}
              alt="Food"
              className="img-fluid rounded shadow-lg"
              style={{
                width: "100%",
                height: "250px",
                objectFit: "cover",
                border: "5px solid #af1831",
                borderRadius: "15px",
              }}
            />
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default FoodGallery;